import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authSlice from './slices/authSlice';
import dashboardSlice from './slices/dashboardSlice';
import masterDataSlice from './slices/masterDataSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'dashboard', 'masterData'], // Persist these slices
};

const rootReducer = combineReducers({
  auth: authSlice,
  dashboard: dashboardSlice,
  masterData: masterDataSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export const persistor = persistStore(store); 